export const translations = {
  en: {
    characterLimitExceeded:
      'Character limit of {{characterLimit}} exceeded for question "{{label}}"',
    isRequiredValue: '"{{label}}" is required',
    invalidAmountAndYearsOfUsage:
      'Values for question "{{label}}" need to specify amount and years of usage',
    invalidAnswerForQuestion: 'Answer is invalid for question "{{label}}"',
    invalidDate: 'Date for question "{{label}}" is invalid',
    invalidEmail: 'Value for question "{{label}}" needs to be a valid email',
    invalidGrossIncomePeriod:
      'Please select a time period for your gross household income',
    invalidGrossIncomeValue: 'Please fill out your gross household income',
    invalidIntervalValue:
      'Value for question "{{label}}" needs to be divisible by {{intervalValue}}',
    invalidMaxValue:
      'Value for question "{{label}}" needs to be less than or equal to {{maxValue}}',
    invalidMinValue:
      'Value for question "{{label}}" needs to be greater than or equal to {{minValue}}',
    invalidNumericValue: 'Value for question "{{label}}" needs to be a number',
    invalidPhoneNumber:
      'Needs to be a valid phone number for question "{{label}}"',
    missingEmergencyContact:
      'Some emergency contact information is missing for "{{label}}"',
    someGuarantorInfoIsMissing: 'Some guarantor information is missing',
    pleaseCompleteQuestion: 'Please complete question "{{label}}"',
    pleaseEnterGuarantorName: 'Please enter the name of your guarantor',
    pleaseSelectAGuarantor: 'Please select a guarantor',
    pleaseSelectGuarantorRelationship: 'Please select guarantor relationship',
    pleaseValidateGuarantorAddress: 'Please validate guarantor address',
    valuesAreAllRequired: 'Values for question "{{label}}" are all required',
    processingCheckin: 'Processing appointment check-in',
    errorProcessingCheckIn:
      'There was an issue processing your appointment check-in. Please see the front desk to complete your check-in.',
  },
  es: {
    characterLimitExceeded:
      'Se superó el límite de caracteres de {{characterLimit}} para la pregunta "{{label}}"',
    isRequiredValue: '"{{label}}" se requiere',
    invalidAmountAndYearsOfUsage:
      'Los valores de la pregunta "{{label}}" deben especificar la cantidad y los años de uso',
    invalidAnswerForQuestion:
      'La respuesta no es válida para la pregunta "{{label}}"',
    invalidDate: 'La fecha de la pregunta "{{label}}" no es válida',
    invalidEmail:
      'El valor de la pregunta "{{label}}" debe ser un correo electrónico válido',
    invalidGrossIncomePeriod:
      'Seleccione un período de tiempo para su ingreso familiar bruto',
    invalidGrossIncomeValue: 'Por favor complete su ingreso familiar bruto',
    invalidIntervalValue:
      'El valor de la pregunta "{{label}}" debe ser divisible por {{intervalValue}}',
    invalidMaxValue:
      'El valor de la pregunta "{{label}}" debe ser menor o igual que {{maxValue}}',
    invalidMinValue:
      'El valor de la pregunta "{{label}}" debe ser mayor o igual que {{minValue}}',
    invalidNumericValue:
      'El valor de la pregunta "{{label}}" debe ser un número',
    invalidPhoneNumber:
      'Debe ser un número de teléfono válido para la pregunta "{{label}}"',
    missingEmergencyContact:
      'Falta alguna información de contacto de emergencia para "{{label}}"',
    someGuarantorInfoIsMissing: 'Falta alguna información del garante',
    pleaseCompleteQuestion: 'Por favor complete la pregunta "{{label}}"',
    pleaseEnterGuarantorName: 'Por favor ingrese el nombre de su garante',
    pleaseSelectAGuarantor: 'Por favor seleccione un garante',
    pleaseSelectGuarantorRelationship: 'Seleccione la relación del garante',
    pleaseValidateGuarantorAddress: 'Por favor valide la dirección del garante',
    valuesAreAllRequired:
      'Los valores para la pregunta "{{label}}" son obligatorios',
  },
};
